import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CATEGORY_BACKGROUND_COLOR_MAP, CATEGORY_COLOR_MAP } from '../../../models/store-attribute.model';
import { ManageValuesEvent, FilterEnabledChangeEvent } from '../attribute-type-row/attribute-type-row.component';
import { StoreAttributeCategoryViewModel, StoreAttributeTypeViewModel } from '../../../models/store-attribute.model';

@Component({
  selector: 'app-store-attribute-category-accordion',
  templateUrl: './category-accordion.component.html',
  styleUrls: ['./category-accordion.component.scss'],
})
export class StoreAttributeCategoryAccordionComponent {
  @Input() category!: StoreAttributeCategoryViewModel;
  @Input() expanded = false;
  @Input() filterToggleSavingId: string | null = null;
  @Output() expandedChange = new EventEmitter<boolean>();
  @Output() addType = new EventEmitter<StoreAttributeCategoryViewModel>();
  @Output() editCategory = new EventEmitter<StoreAttributeCategoryViewModel>();
  @Output() manageValues = new EventEmitter<ManageValuesEvent>();
  @Output() deleteType = new EventEmitter<StoreAttributeTypeViewModel>();
  @Output() filterEnabledChange = new EventEmitter<FilterEnabledChangeEvent>();

  get attributeTypeCountLabel(): string {
    const count = this.category.attributeTypes.length;
    return `${count} attribute type${count === 1 ? '' : 's'}`;
  }

  onToggle(): void {
    this.expandedChange.emit(!this.expanded);
  }

  get accentColor(): string {
    return CATEGORY_COLOR_MAP[this.category.color];
  }

  get headerBackgroundColor(): string {
    return CATEGORY_BACKGROUND_COLOR_MAP[this.category.color];
  }

  onAddType(event: MouseEvent): void {
    event.stopPropagation();
    this.addType.emit(this.category);
  }

  onEditCategory(event: MouseEvent): void {
    event.stopPropagation();
    this.editCategory.emit(this.category);
  }
}
